import { Injectable } from '@angular/core';
import { UserService } from '../../../auth/user.service';
import { CommonUtil } from '../../../shared/services/utility/common.service';
import { CommonDataService } from '../../../shared/services/common-data.service';

@Injectable()
export class PolarLinkService {

	polarlinkSNRules = [
		{type: 'string', min: 14, max: 14},
		{type: 'regex', patt: /^13131(0[1-9]|1[0-2])[0-9]{2}2[0-9]{4}$/}
	];

	constructor(private userService: UserService, private commonUtil: CommonUtil, private commonData: CommonDataService) { }

	validatePolarLinkSettings(polarlink, isBulk, oldPolarLink, originalBattviewsInfo) {

		let minInstallationDate = new Date(new Date().setFullYear(new Date().getFullYear()-1)); //'1 year ago'
		let maxInstallationDate = new Date(new Date().setFullYear(new Date().getFullYear()+1)); //'1 year from now'

		var maxSSIDpasswordLength = 32;
		// if(oldPolarLink.battviewversion == 2)
		// 	maxSSIDpasswordLength = 31;

		let validationRules = {
			'serialnumber'						: this.polarlinkSNRules,
			'hwversion'							: [{type: 'string', min: 1, max: 2}, {type: 'regex', patt: /^([a-zA-Z ]{1,2})$/}], //format: "A" -> "ZZ"
			'autologtime'						: [{type: 'integer', min: 1, max: 65535}],
			'enabledaylightsaving'				: [{type: 'boolean'}],
			'mobileaccessssid'					: [{type: 'string', min: 8, max: 31}, {type: 'regex', patt: /^[^'" ]*$/}],
			'mobileaccessssidpassword'			: [{type: 'string', min: 8, max: 13}, {type: 'regex', patt: /^[^'" ]*$/}],
			'mobileport'						: [{type: 'integer', min: 49152, max: 65535}],
			'actviewenabled'					: [{type: 'boolean'}],
			'actviewip'							: [{type: 'string', min: 7, max: 31}, {type: 'regex', patt: /^[^'" ]*$/}],
			'actviewport'						: [{type: 'integer', min: 1024, max: 65535}],
			'actviewconnectfrequency'			: [{type: 'integer', min: 1, max: 65535}],
			'actaccessssid'						: [{type: 'string', min: 1, max: 31}, {type: 'regex', patt: /^[^'" ]*$/}],
			'actaccessssidpassword'				: [{type: 'string', min: 8, max: maxSSIDpasswordLength}, {type: 'regex', patt: /^[^'" ]*$/}],
			'rseid'								: [{type: 'string', min: 1, max: 17}],
			'rsesn'								: [{type: 'string', min: 0, max: 17}],
			'model'								: [{type: 'string', min: 0, max: 17}],
			'truckid'							: [{type: 'string', min: 0, max: 17}],
			'installationdate'					: [{type: 'integer', min: Math.floor(minInstallationDate.getTime() / 1000), max: Math.floor(maxInstallationDate.getTime() / 1000)}],
			'zoneid'							: [{type: 'integer', min: 0, max: 107}],
			'warrantedahr'						: [{type: 'integer', min: 125000, max: 6250000}],
		};

		let access = this.userService.getCurrentUser()['userAccess'];

		let invalidFields = [];

		for(let field in polarlink) {

			let accessField = this.commonData.accessFieldsMapper['plink'][field];
			if(accessField) {

				let permission = this.getPermissionWithFallback(access, accessField);
				if(permission == 'write') {

					let rules = validationRules[field] || [];
					for (let i = 0; i < rules.length; i++) {
						let rule = rules[i];

						if(invalidFields.indexOf(field) == -1) {

							let isValid = this.commonUtil.dataValidator(rule.type, rule, polarlink[field]);

							if(!isValid)
								invalidFields.push(field);
						}
					}
				} 
				// else {

				// 	let isValid = false;
				// 	if(field == 'warrantedahr' && polarlink.ahrcapacity) {
				// 		if(polarlink.warrantedahr == (polarlink.ahrcapacity*1250))
				// 			isValid = true;
				// 	}

				// 	if(!isValid)
				// 		invalidFields.push(field);
				// }
			}
		}

		return invalidFields;
	}

	// validateStudy(study) {
	// 	let validationRules = {
	// 		'studyname'			: [{type: 'string', min: 1, max: 17}],
	// 		'truckid'			: [{type: 'string', min: 1, max: 17}],
	// 	};

	// 	let invalidFields = [];

	// 	for(let field in study) {
	// 		let rules = validationRules[field] || [];
	// 		for (const rule of rules) {

	// 			if(invalidFields.indexOf(field) == -1) {

	// 				let isValid = this.commonUtil.dataValidator(rule.type, rule, study[field]);

	// 				if(!isValid)
	// 					invalidFields.push(field);
	// 			}
	// 		}
	// 	}

	// 	return invalidFields;
	// };

	formatProductionLineErrors(err) {
		var typeMsg = {
			'disconnected':	"* Device didn't connect recently:",
			'old_firmware':	"* Device didn't finish firmware update:",
			'has_errors':	"* Device errors:",
			'has_queue':	"* Commands not executed:",
			'no_reset':		"* Can not edit device:"
		};

		var errorMessage = "";

		for(var type in err) {
			if(err[type].length > 0) {
				errorMessage += typeMsg[type] + '<br/>';
				errorMessage += err[type].join(', ') + '<br/>';
			}
		}

		return errorMessage;
	}

	/**
	 * Get permission value with bidirectional backward compatibility for spelling corrections
	 * Handles both directions since we don't know which spelling the user has in their database
	 */
	private getPermissionWithFallback(access: any, fieldName: string): string {
		// First try the requested spelling
		if(access[fieldName] !== undefined) {
			return access[fieldName];
		}

		// Bidirectional compatibility for _actAccessSSIDPassword <-> _actAccessSSIDpassword
		if(fieldName.includes('_actAccessSSIDPassword')) {
			const legacyFieldName = fieldName.replace('_actAccessSSIDPassword', '_actAccessSSIDpassword');
			if(access[legacyFieldName] !== undefined) {
				return access[legacyFieldName];
			}
		} else if(fieldName.includes('_actAccessSSIDpassword')) {
			const correctFieldName = fieldName.replace('_actAccessSSIDpassword', '_actAccessSSIDPassword');
			if(access[correctFieldName] !== undefined) {
				return access[correctFieldName];
			}
		}

		// Bidirectional compatibility for _mobileAccessSSIDPassword <-> _mobileAccessSSIDpassword
		if(fieldName.includes('_mobileAccessSSIDPassword')) {
			const legacyFieldName = fieldName.replace('_mobileAccessSSIDPassword', '_mobileAccessSSIDpassword');
			if(access[legacyFieldName] !== undefined) {
				return access[legacyFieldName];
			}
		} else if(fieldName.includes('_mobileAccessSSIDpassword')) {
			const correctFieldName = fieldName.replace('_mobileAccessSSIDpassword', '_mobileAccessSSIDPassword');
			if(access[correctFieldName] !== undefined) {
				return access[correctFieldName];
			}
		}

		// Bidirectional compatibility for _onlyForEngineeringTeam <-> _onlyForEnginneringTeam
		if(fieldName.includes('_onlyForEngineeringTeam')) {
			const legacyFieldName = fieldName.replace('_onlyForEngineeringTeam', '_onlyForEnginneringTeam');
			if(access[legacyFieldName] !== undefined) {
				return access[legacyFieldName];
			}
		} else if(fieldName.includes('_onlyForEnginneringTeam')) {
			const correctFieldName = fieldName.replace('_onlyForEnginneringTeam', '_onlyForEngineeringTeam');
			if(access[correctFieldName] !== undefined) {
				return access[correctFieldName];
			}
		}

		// Default to undefined if no permission found
		return undefined;
	}

	/**
	 * Get all alternate spellings for a given permission name
	 * Used for secure permission management to prevent conflicts
	 */
	private getAlternateSpellings(permissionName: string): string[] {
		const alternates: string[] = [];

		if (permissionName.includes('_actAccessSSIDPassword')) {
			alternates.push(permissionName.replace('_actAccessSSIDPassword', '_actAccessSSIDpassword'));
		} else if (permissionName.includes('_actAccessSSIDpassword')) {
			alternates.push(permissionName.replace('_actAccessSSIDpassword', '_actAccessSSIDPassword'));
		}

		if (permissionName.includes('_mobileAccessSSIDPassword')) {
			alternates.push(permissionName.replace('_mobileAccessSSIDPassword', '_mobileAccessSSIDpassword'));
		} else if (permissionName.includes('_mobileAccessSSIDpassword')) {
			alternates.push(permissionName.replace('_mobileAccessSSIDpassword', '_mobileAccessSSIDPassword'));
		}

		if (permissionName.includes('_onlyForEngineeringTeam')) {
			alternates.push(permissionName.replace('_onlyForEngineeringTeam', '_onlyForEnginneringTeam'));
		} else if (permissionName.includes('_onlyForEnginneringTeam')) {
			alternates.push(permissionName.replace('_onlyForEnginneringTeam', '_onlyForEngineeringTeam'));
		}

		return alternates;
	}

	/**
	 * Securely remove permission and all alternate spellings
	 * Prevents security vulnerability where removed permissions persist through legacy spellings
	 */
	private removePermissionSecurely(userAccess: any, permissionName: string): any {
		const newAccess = { ...userAccess };

		// Remove the requested permission
		delete newAccess[permissionName];

		// Remove all alternate spellings to prevent privilege persistence
		const alternates = this.getAlternateSpellings(permissionName);
		alternates.forEach(alt => delete newAccess[alt]);

		return newAccess;
	}

	/**
	 * Securely grant permission, preventing conflicts with alternate spellings
	 * Removes any existing alternate spellings to ensure consistent access control
	 */
	private grantPermissionSecurely(userAccess: any, permissionName: string, value: string): any {
		const newAccess = { ...userAccess };

		// Remove any alternate spellings first to prevent conflicts
		const alternates = this.getAlternateSpellings(permissionName);
		alternates.forEach(alt => delete newAccess[alt]);

		// Grant the permission with the requested spelling
		newAccess[permissionName] = value;

		return newAccess;
	}

	/**
	 * Validate that no conflicting permissions exist in user access
	 * Returns details about any conflicts found
	 */
	private validateNoConflicts(userAccess: any): { hasConflicts: boolean, conflicts: string[] } {
		const conflicts: string[] = [];

		// Check for each type of spelling conflict
		const permissionTypes = [
			{ correct: '_actAccessSSIDPassword', legacy: '_actAccessSSIDpassword' },
			{ correct: '_mobileAccessSSIDPassword', legacy: '_mobileAccessSSIDpassword' },
			{ correct: '_onlyForEngineeringTeam', legacy: '_onlyForEnginneringTeam' }
		];

		Object.keys(userAccess).forEach(permission => {
			permissionTypes.forEach(type => {
				if (permission.includes(type.correct)) {
					const legacyVersion = permission.replace(type.correct, type.legacy);
					if (userAccess[legacyVersion] !== undefined) {
						conflicts.push(`${permission} (${userAccess[permission]}) conflicts with ${legacyVersion} (${userAccess[legacyVersion]})`);
					}
				}
			});
		});

		return { hasConflicts: conflicts.length > 0, conflicts };
	}
}
